export default __webpack_public_path__ + "static/media/per-access-science.6dfd464f.svg";